// ----------------------------------------------------------------------------------
// Chat Path Connection Config
// ----------------------------------------------------------------------------------
const chatServerProtocol = 'https://'
const chatServerSocketProtocol = 'wss://'
const chatServerDomain = 'chat.aladdinb2b.com'
// const chatServerPort = '443'
const chatServerVersion = 'api/v1'
export const chatServerURL = `${chatServerProtocol}${chatServerDomain}`
export const chatServerURLWithVersion = `${chatServerURL}/${chatServerVersion}`
export const chatServerSocketURL = `${chatServerSocketProtocol}${chatServerDomain}/websocket`
// ----------------------------------------------------------------------------------

// ----------------------------------------------------------------------------------
// End Point Path Connection Config
// ----------------------------------------------------------------------------------
const endpointProtocol = 'https://'
const endpointDomain = 'www.aladdinb2b.com'
const endPointVersion = 'api/v0.3'
export const endpointURL = `${endpointProtocol}${endpointDomain}`
export const endpointURLWithVersion = `${endpointURL}/${endPointVersion}`
export const endpointURLFull = `${endpointURLWithVersion}/`
// ----------------------------------------------------------------------------------

// ----------------------------------------------------------------------------------
// Comman Variable
// ----------------------------------------------------------------------------------
export const defaultPrimaryColor = '#ff681a'
export const defaultLightColor = '#FFF'
export const defaultDarkColor = '#000'

export const listSize = 100
// ----------------------------------------------------------------------------------
